module.exports = __webpack_public_path__ + "203fa4c89ffc288c04cd5c1e9819ad47.png";